module.exports = __webpack_public_path__ + "static/img/recharge_loading.c0ef176.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recharge_loading.png
// module id = 2f1L
// module chunks = 1